module.exports = __webpack_public_path__ + "img/mailMessage.14c6ea80.png";